import type { IconData } from '@stacksjs/iconify-core'

export const devicesCamera: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3 3H0v12h16V3h-3l-2-2H5zm5 8.5a3 3 0 1 0 0-6a3 3 0 0 0 0 6\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default devicesCamera
